import { normalize } from 'normalizr';

import Resources from '@helpers/resources';

import { resetAssignmentHashKeys, disableShowGridLoader } from '@containers/upf-assign/upf-assign-actions';

import Schema from '@containers/entities/schema';
import { updateEntities } from '@containers/entities/entities-reducer';

import * as actionTypes from './gateways-action-types';

export const fetchErrorDetected = () => ({ type: actionTypes.ERROR_DETECTED });

/**
 * Assignments
 */

export const fetchStudentAssignmentsStatusesRequest = () => ({
  type: actionTypes.STUDENTS_ASSIGNMENTS_STATUSES_REQUEST
});
export const fetchStudentAssignmentsStatusesSuccess = () => ({
  type: actionTypes.STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS
});

export const fetchAssignAssignmentsRequest = () => ({ type: actionTypes.ASSIGN_ASSIGNMENTS_REQUEST });
export const fetchAssignAssignmentsSuccess = () => ({ type: actionTypes.ASSIGN_ASSIGNMENTS_SUCCESS });

export const fetchUnAssignAssignmentsRequest = () => ({ type: actionTypes.UNASSIGN_ASSIGNMENTS_REQUEST });
export const fetchUnAssignAssignmentsSuccess = () => ({ type: actionTypes.UNASSIGN_ASSIGNMENTS_SUCCESS });

export const getAssignments =
  ({ productId, classId, courseId, courseVersion, assignmentResultType }) =>
    async dispatch => {
      try {
        dispatch(fetchStudentAssignmentsStatusesRequest());

        const { data } = await Resources.assignments
          .get({ productId, classId, courseId, version: courseVersion })
          .withParams({ assignmentResultType })
          .send();

        if (!data) {
          throw new Error('GET Students assignments Failed');
        }

        const normalizedData = normalize(data, Schema.STUDENT_WITH_ASSIGNMENTS_ARRAY);
        dispatch(updateEntities(normalizedData));
        dispatch(fetchStudentAssignmentsStatusesSuccess());
        return dispatch(disableShowGridLoader());
      } catch (err) {
        dispatch(fetchErrorDetected());
        return null;
      }
    };

export const postAssignAssignments = requestData => async dispatch => {
  try {
    dispatch(fetchAssignAssignmentsRequest());

    const response = await Resources.assign.post().withBody(requestData).send();

    if (!response.data) {
      throw new Error('POST Assign assignments failed');
    }

    dispatch(fetchAssignAssignmentsSuccess());
    return dispatch(resetAssignmentHashKeys());
  } catch (err) {
    dispatch(fetchErrorDetected());
    return null;
  }
};

export const deleteUnAssignAssignments =
  (requestData = []) =>
    async dispatch => {
      try {
        dispatch(fetchUnAssignAssignmentsRequest());

        const response = await Resources.unassign.delete().withBody(requestData).send();

        if (!response.data) {
          throw new Error('DELETE Unassign assignments failed');
        }

        dispatch(fetchUnAssignAssignmentsSuccess());
        return dispatch(resetAssignmentHashKeys());
      } catch (err) {
        dispatch(fetchErrorDetected());
        return null;
      }
    };

export const fetchPreviewAssignmentRequest = () => ({ type: actionTypes.PREVIEW_ASSIGNMENT_REQUEST });
export const fetchPreviewAssignmentSuccess = () => ({ type: actionTypes.PREVIEW_ASSIGNMENT_SUCCESS });

export const postPreviewAssignment =
  ({ productId, courseId, courseVersion, learningJourneyId, locale }) =>
    async dispatch => {
      try {
        dispatch(fetchPreviewAssignmentRequest());

        const response = await Resources.previewAssignment
          .post()
          .headers({ Locale: locale })
          .withBody({
            productId,
            courseId,
            courseVersion,
            learningJourneyId
          })
          .send();

        if (!response.data) {
          throw new Error(response?.message);
        }

        dispatch(fetchPreviewAssignmentSuccess());
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    };

export const fetchClassroomsRequest = () => ({ type: actionTypes.CLASSROOMS_REQUEST });
export const fetchClassroomsSuccess = () => ({ type: actionTypes.CLASSROOMS_SUCCESS });
